module.exports = __webpack_public_path__ + "media/images/workplace/WorkplaceAppBanner-0ef02543d6649ce30001bdeba6d1700e.jpeg";